module.exports = "/images/vendor/flag-icon-css/flags/1x1/fr.svg?f8952213641bba462c7314007909d394";